import { render, staticRenderFns } from "./GridTableFull.vue?vue&type=template&id=c9f58a5e&scoped=true"
import script from "./GridTableFull.vue?vue&type=script&lang=js"
export * from "./GridTableFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f58a5e",
  null
  
)

export default component.exports